import axios from 'axios'
import qs from 'qs'
import configUrl from '@/config'
import apiService from '@/services/apiService'

export default {
  gettingAccessTokenLine: async function ({ commit }, payload) {
    var data = qs.stringify({
      grant_type: 'authorization_code',
      code: payload.code,
      redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''
        }/${payload.path}`,
      client_id: configUrl.line_client_id,
      client_secret: configUrl.client_secret
    })
    var config = {
      method: 'post',
      url: 'https://api.line.me/oauth2/v2.1/token',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: data
    }
    var response = await axios(config)
    commit('GET_ACCESSTOKEN_LINE', response)
  },
  getProfile: async function (store, payload) {
    var config = {
      method: 'get',
      url: 'https://api.line.me/v2/profile',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${payload.access_token}`
      }
    }
    return await axios(config)
  },

  createAccount: async function (store, accountData) {
    try {
      // console.log(commit);
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post('create_account', accountData, {
        params: { business_id }
      })
      return response.data.data[0]
    } catch (error) {
      return error.response.data.reason
    }
  },

  emailLogin: async function (store, dataToLogin) {
    const business_id = sessionStorage.getItem('businessId')
    var response = await apiService.post(
      'login_account',
      {
        password: dataToLogin.password,
        'g-recaptcha-response': dataToLogin.recaptcha
      },
      {
        params: { email: dataToLogin.email, business_id }
      }
    )
    return response
  },

  socialLogin: async function (store, dataToLogin) {
    console.log(dataToLogin.param)
    const business_id = sessionStorage.getItem('businessId')
    var response = await apiService.post(
      'login_account',
      {
        'g-recaptcha-response': dataToLogin.recaptcha
      },
      {
        params: { ...dataToLogin.login, business_id }
      }
    )
    return response
  },

  setDataRegisterLine: async function ({ commit }, payload) {
    commit('SET_DATAREGISTERLINE', payload)
  },

  setDataRegisterFB: async function ({ commit }, payload) {
    commit('SET_DATAREGISTERFB', payload)
  },

  clearDataRegister: async function ({ commit }, payload) {
    commit('CLEAR_DATAREGISTER', payload)
  },

  setIsAuthenticated: async function ({ commit }, payload) {
    commit('SET_ISAUTHENTICATED', payload)
  },

  setShopProfile: async function ({ commit }, payload) {
    commit('SET_SHOPPROFILE', payload)
  },

  updateAccount: async function ({ commit }, payload) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('update_account', payload, {
        params: { business_id }
      })
      commit('EDIT_ACCOUNT', response.data.data[0])
      return response.data.data[0]
    } catch (error) {
      return null
    }
  },
  changePassword: async function (state, payload) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('change_password_account', payload, {
        params: { business_id }
      })

      return response.data.data[0]
    } catch (error) {
      return null
    }
  },

  syncLine: async function (state, payload) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('sync_account_line', payload, {
        params: { business_id }
      })

      localStorage.setItem('profile', JSON.stringify(response.data.data[0]))
      return response.data.data[0]
    } catch (error) {
      return null
    }
  },

  syncFacebook: async function (state, payload) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('sync_account_facebook', payload, {
        params: { business_id }
      })

      localStorage.setItem('profile', JSON.stringify(response.data.data[0]))
      return response.data.data[0]
    } catch (error) {
      return error.response.data.reason
    }
  },

  getShopProfile: async function (store, businessId) {
    try {
      var response = await apiService.get(
        `api/business/profile/${businessId}/account`
      )
      const profile = response.data.data[0]
      if (profile) {
        this.dispatch('login/setShopProfile', profile)
      }
      return profile
    } catch (error) {
      return error.response?.data?.reason || error
    }
  },

  logout: async function () {
    this.dispatch('setOverlay', true)
    localStorage.clear()
    this.dispatch('login/clearDataRegister', null)
    this.dispatch('login/setIsAuthenticated', 'false')
    this.dispatch('setOverlay', false)
  }
}
